import React from "react";
import { useTranslation } from "react-i18next";
//Components
import { FooterContainer, ManagementDiv, SaveAndCancelDiv, SaveButton, CancelButton } from "./styles";
import ButtonWithIcon from "../../../../buttonWithIcon";
// Assets
import EditUserImg from "../../../../../assets/btn_edit_user.svg";

const Footer = ({ handleSubmit, isDisabledInputs, setIsDisabledInputs }) => {
  const [t] = useTranslation("global");

  const handleAvailableData = (e) => {
    e.preventDefault();
    setIsDisabledInputs(false);
  };
  const handleDisabledData = (e) => {
    e.preventDefault();
    window.location.reload();
  };

  return (
    <FooterContainer>
      {isDisabledInputs ? (
        <ManagementDiv justifyContent="flex-start">
          <ButtonWithIcon
            icon={EditUserImg}
            name={t("prescriptions.editPrescriptionsButton")}
            onClick={handleAvailableData}
          />
        </ManagementDiv>
      ) : (
        <ManagementDiv justifyContent="space-between">
          <SaveAndCancelDiv>
            <SaveButton onClick={handleSubmit}>{t("prescriptions.saveButton")}</SaveButton>
            <CancelButton onClick={handleDisabledData}>{t("prescriptions.discardChangesButton")}</CancelButton>
          </SaveAndCancelDiv>
        </ManagementDiv>
      )}
    </FooterContainer>
  );
};

export default Footer;
